import { JsonServiceClient } from "@servicestack/client"

export const client = new JsonServiceClient(import.meta.env.VITE_API_URL)
    .apply(c => {
        c.basePath = "/api"
        c.headers = new Headers() //avoid pre-flight CORS requests
    });

export default client;